<template>
	<div class="media widthz">
		<div class="navGo flex ">
			<span @click="goHomg()">首页></span>
			<span>详情</span>
		</div>

		<section class="widthWhite">
			<hgroup>
				<h6>{{detail.Name}}</h6>
				<p class="flex zhong center">{{detail.CreateTime}}</p>
			</hgroup>
			<article class="details_nei fwbhtml" v-html="detail.Profit">
				<!-- {{detail.Profit}} -->
			</article>
		</section>
	</div>
</template>
<script>
	export default {
		name: 'media',
		data() {
			return {
				detailId: 0,
				detail: {}
			};
		},
		mounted() {
			console.log('页面传参' + this.$route.query);
			this.detailId = this.$route.query.Id ? this.$route.query.Id : 0;
			this.GetDetail();
		},
		methods: {
			// 返回首页
			goHomg() {
				this.$router.push('/home');
			},
			// 获取详情
			GetDetail: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetProjectDetail?Id=' + that.detailId,
					'GET', {},
					function(res) {
						console.log('获取详情');
						console.log(res);
						if (res.code === 0) {
							that.detail = res.data;
							// document.getElementById('detailInfo').innerHTML = res.data.Detail;
						}
					},
					function(res) {}
				);
			}
		}
	};
</script>
<style scoped>
	.details_nei>>>img {
		display: block;
		width: 100%;
	}

	.details_nei {
		font-size: 14px;
	}

	.widthWhite hgroup p span {
		margin: 0 20px;
	}

	.widthWhite hgroup p {
		margin-top: 20px;
		font-size: 12px;
		color: #666;
	}

	.widthWhite hgroup h6 {
		font-weight: normal;
		font-size: 16px;
		text-align: center;
	}

	.widthWhite hgroup {
		padding: 0 0 20px 0;
		margin-bottom: 20px;
		border-bottom: solid 1px #e6e6e6;
	}
</style>
